import gql from 'graphql-tag'

const CUSTOMER_CREATE_UPDATE_MUTATION = gql`
    mutation ($input: CustomerMutationInput!) {
        customer(input: $input){
            name
            lastName
            errors{
                field
                messages
            }
        }
    } 
`

const CUSTOMER_UPDATE_STATUS = gql`
    mutation chageStatusCustomer($id: ID, $status: Boolean!) {
        chageStatusCustomer(id: $id, status: $status) {
            ok
        }
    }
`

const CUSTOMER_DELETE = gql`
    mutation ($id: ID) {
        deleteCustomer (id: $id) {
            ok
        }
    }
`

export {
    CUSTOMER_CREATE_UPDATE_MUTATION,
    CUSTOMER_UPDATE_STATUS,
    CUSTOMER_DELETE
}
